import { Form, Input, Modal, Select } from "antd";
import { useEffect } from "react";
import { Currency, SupplierType } from "../../enum/common";
import { IPurchaseFilter, IPurchaseSupplier } from "../../models/Purchase";
import { useUpdateSupplier } from "../../query/PurchaseQuery";
import { notify } from "../../utils/toast";

interface IModalEditSupplierProps {
  open: boolean;
  record: IPurchaseSupplier | null;
  params: IPurchaseFilter;
  onCancel: () => void;
  onSuccess: () => void;
}

const ModalEditSupplier = ({
  open,
  record,
  params,
  onCancel,
  onSuccess,
}: IModalEditSupplierProps) => {
  const [form] = Form.useForm();
  const updateSupplier = useUpdateSupplier();

  useEffect(() => {
    if (record && open) {
      form.setFieldsValue({
        name: record.name,
        email: record.email,
        type: record.type,
        country: record.country,
        currency: record.currency,
      });
    }
  }, [record, open, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await updateSupplier.mutateAsync({
        id: record!.id,
        data: values,
        query: params,
      });
      notify.success("Cập nhật nhà cung cấp thành công");
      form.resetFields();
      onSuccess();
    } catch (error) {
      notify.error("Cập nhật nhà cung cấp thất bại");
    }
  };

  return (
    <Modal
      title="Chỉnh sửa nhà cung cấp"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      confirmLoading={updateSupplier.isPending}
      okText="Cập nhật"
      cancelText="Hủy"
      width={600}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Tên nhà cung cấp"
          name="name"
          rules={[
            { required: true, message: "Vui lòng nhập tên nhà cung cấp" },
          ]}
        >
          <Input placeholder="Nhập tên nhà cung cấp" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Vui lòng nhập email" },
            { type: "email", message: "Email không hợp lệ" },
          ]}
        >
          <Input placeholder="Nhập email" />
        </Form.Item>

        <Form.Item
          label="Loại nhà cung cấp"
          name="type"
          rules={[{ required: true, message: "Vui lòng chọn loại" }]}
        >
          <Select placeholder="Chọn loại nhà cung cấp">
            <Select.Option value={SupplierType.LOCAL}>Nội địa</Select.Option>
            <Select.Option value={SupplierType.ONLINE}>
              Trực tuyến
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Quốc gia"
          name="country"
          rules={[{ required: true, message: "Vui lòng nhập quốc gia" }]}
        >
          <Input placeholder="Nhập quốc gia" />
        </Form.Item>

        <Form.Item
          label="Tiền tệ"
          name="currency"
          rules={[{ required: true, message: "Vui lòng chọn tiền tệ" }]}
        >
          <Select placeholder="Chọn tiền tệ">
            <Select.Option value={Currency.VND}>VND</Select.Option>
            <Select.Option value={Currency.USD}>USD</Select.Option>
            <Select.Option value={Currency.EUR}>EUR</Select.Option>
            <Select.Option value={Currency.CNY}>CNY</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditSupplier;
